<form *ngIf="!gesendet" [formGroup]="formGroup" class="tab-content">
    <px-error-box #fehlerboxComponent></px-error-box>

    <fieldset class="ba-layout-tile">
        <div class="pflichtfeld">* Pflichtfeld</div>

        <h2 id="vm_falldatenHeader_txt">Falldaten</h2>

        <div class="row ba-form-row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <px-radio-group formControlName="veraenderungsart" id="vm_veraenderungsart">
                    <div class="col-xs-12">
                        <label pxRadioMainLabel
                            >Veränderungsart
                            <button
                                content="Wählen Sie
                                    <br><b><li>Eintritt</b>, um erstmals für einen Beschäftigten (Bezügeempfänger) Kindergelddaten abrufen zu können
                                    <br><b><li>Austritt</b>, wenn Sie für einen Beschäftigten keine Kindergelddaten mehr benötigen
                                    <br><b><li>Zu berücksichtigende Kinder hinzufügen</b>, um für weitere Kinder eines Beschäftigten Kindergelddaten abrufen zu können
                                    <br><b><li>Zu berücksichtigende Kinder entfernen</b>, wenn Sie für einzelne Kinder eines Beschäftigten keine Kindergelddaten mehr benötigen
                                    <br><b><li>Ordnungskriterium ändern</b>, um Ihr Ordnungskriterium (z.B. Personalnummer) für einen Beschäftigten zu ändern."
                                id="vm_veraenderungsart_help"
                                pxTooltip="help"
                                title="Veränderungsart"
                                trigger="click"
                                type="button"
                                html="true"
                            ></button>
                        </label>
                        <px-radio-button id="vm_veraenderungsartEintritt" value="EINTRITT">Eintritt</px-radio-button>
                        <px-radio-button id="vm_veraenderungsartAustritt" value="AUSTRITT">Austritt</px-radio-button>
                        <px-radio-button id="vm_veraenderungsartKinderPlus" value="KINDERPLUS"
                            >Zu berücksichtigende Kinder hinzufügen</px-radio-button
                        >
                        <px-radio-button id="vm_veraenderungsartKinderMinus" value="KINDERMINUS"
                            >Zu berücksichtigende Kinder entfernen</px-radio-button
                        >
                        <px-radio-button id="vm_veraenderungsartOrdnungskriterium" value="ORDNUNGSKRITERIUM"
                            >Ordnungskriterium ändern</px-radio-button
                        >
                    </div>
                </px-radio-group>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                <px-date formControlName="veraenderungsdatum" id="vm_eintrittsdatum" placeholder="TT.MM.JJJJ">{{
                    veraenderungNachrichtLabel
                }}</px-date>
            </div>
        </div>

        <h2 class="padding-top-20" id="vm_BeschaeftigtenHeader_txt">Daten der/ des Beschäftigten</h2>

        <div class="row ba-form-row">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                <px-input formControlName="mitarbeiterNachname" id="vm_mitarbeiter_nachname" maxLength="30"
                    >Nachname
                </px-input>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                <px-input formControlName="mitarbeiterVorname" id="vm_mitarbeiter_vorname" maxLength="30"
                    >Vorname
                </px-input>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                <px-date
                    formControlName="mitarbeiterGeburtsdatum"
                    id="vm_mitarbeiter_geburtsdatum"
                    placeholder="TT.MM.JJJJ"
                    >Geburtsdatum
                </px-date>
            </div>
        </div>

        <div class="row ba-form-row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                <px-input
                    formControlName="kindergeldnummer"
                    id="vm_kindergeldnummer"
                    maxLength="11"
                    placeholder="xxxFKxxxxxx"
                    >Kindergeldnummer
                    <button
                        content="Die Kindergeldnummer besteht aus insgesamt 11 Zeichen. Die Kindergeldnummer ist wie folgt aufgebaut: &Prime;xxxFKxxxxxx&Prime;. 
                          Bitte beachten Sie, dass das &Prime;x&Prime; durch jeweils eine Ziffer zu ersetzen ist."
                        id="vm_kindergeldnummer_help"
                        pxTooltip="help"
                        title="Kindergeldnummer"
                        trigger="click"
                        type="button"
                    ></button>
                </px-input>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                <px-input
                    formControlName="ordnungkriterium"
                    id="vm_zahlstellennummer"
                    maxLength="30"
                    placeholder="z. B. Personalnummer"
                    trimInput
                    >{{ zahlenstellenNummerLabel }}
                    <button
                        content="Das Ordnungskriterium ist das von Ihnen vergebene Merkmal zur Identifikation Ihres Beschäftigten, 
                          welches Sie der Familienkasse übermittelt haben. Zum Beispiel die Personalnummer."
                        id="vm_zahlstellennummer-help"
                        pxTooltip="help"
                        title="Ordnungskriterium des Arbeitgebers"
                        trigger="click"
                        type="button"
                    ></button>
                </px-input>
            </div>

            <div *ngIf="isOrdnungskriteriumSelected" class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                <px-input
                    formControlName="ordnungkriteriumNew"
                    id="vm_zahlstellennummerNew"
                    maxLength="30"
                    placeholder="z. B. Personalnummer"
                    trimInput
                    >künftiges Ordnungskriterium des Arbeitgebers
                </px-input>
            </div>
        </div>

        <odbs-kind *ngIf="!isOrdnungskriteriumSelected" [formGroup]="formGroup" prefixId="vm"></odbs-kind>

        <div aria-label="Hinweis" class="alert alert-info" role="note">
            <p id="rsa_hinweisAnlageStarten">
                Eintragungen im Freitextfeld dürfen nur erfolgen, soweit sie im Einzelfall für die Erledigung der
                Mitteilungspflichten nach § 5 KiGAbV erforderlich sind. Hierzu zählen insbesondere die für die Zuordnung
                Ihrer Anfrage erforderlichen Angaben zu anderen Personen, die Kindergeld für die zu berücksichtigenden
                Kinder beziehen (Name, Vorname, Geb.-Datum, Anschrift, abweichende Kindergeldnummer)
            </p>
        </div>

        <div class="row ba-form-row">
            <div class="col-lg-12">
                <px-textarea formControlName="veraenderungNachricht" id="vm_veraenderung_nachricht" maxLength="1000"
                    >Freitextfeld
                </px-textarea>
            </div>
        </div>

        <h2 id="vm_ErforderlicheErklaerungHeader_txt">Erforderliche Kenntnisnahme und Erklärung</h2>

        <div class="row ba-form-row">
            <div class="col-lg-12">
                <px-checkbox
                    [attr.data-label]="
                        'Die Vorraussetzungserklärung für den Datenabruf gemäß der Kindergeldaten-Abrufverordnung (KiGAbV)'
                    "
                    formControlName="erklaerung"
                    id="vm_erklaerung"
                >
                    <p id="vm_erklaerung_txt">
                        <span *ngIf="veraenderungsart !== 'AUSTRITT'"
                            >Da ich als Bezügestelle des öffentlichen Dienstes für den o.a. Beschäftigten Bezüge unter
                            Berücksichtigung der aufgeführten Kinder anweise, bitte ich den für die jeweilige
                            Kindergeldzahlung maßgebenden Sachverhalt durch einen automatisierten Abruf
                            bereitzustellen.</span
                        >
                        <span *ngIf="veraenderungsart === 'AUSTRITT'"
                            >Da ich als Bezügestelle des öffentlichen Dienstes für den o.a. Beschäftigten keine Bezüge
                            mehr unter Berücksichtigung der aufgeführten Kinder anweise, bitte ich den für die jeweilige
                            Kindergeldzahlung maßgebenden Sachverhalt durch einen automatisierten Abruf nicht mehr
                            bereitzustellen.</span
                        >
                    </p>
                    <p id="vm_erklaerung2_txt">
                        <span *ngIf="veraenderungsart !== 'AUSTRITT'"
                            >Ich erkläre hiermit, dass die Voraussetzungen für den Datenabruf gemäß der
                            Kindergelddaten-Abrufverordnung (KiGAbV) vorliegen.</span
                        >
                    </p>
                </px-checkbox>
            </div>
        </div>

        <div class="d-flex flex-column flex-sm-row justify-content-between">
            <px-button (buttonClicked)="formularLeeren()" buttonStyleType="secondary" id="vm_formularLeeren"
                >Formular leeren
            </px-button>
            <px-button (buttonClicked)="absenden()" id="vm_absenden">Absenden </px-button>
        </div>
    </fieldset>
</form>

<div *ngIf="gesendet" [formGroup]="formGroup" class="tab-content ba-bg-bright">
    <app-mitteilung-gesendet (neueAnfrage)="init()"></app-mitteilung-gesendet>
</div>
